/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'enter': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M512 60v392c0 33.086-26.914 60-60 60H211c-33.086 0-60-26.914-60-60v-80h40v80c0 11.027 8.973 20 20 20h241c11.027 0 20-8.973 20-20V60c0-11.027-8.973-20-20-20H211c-11.027 0-20 8.973-20 20v80h-40V60c0-33.086 26.914-60 60-60h241c33.086 0 60 26.914 60 60zM212.715 322L241 350.285 335.285 256 241 161.715 212.715 190l46 46H0v40h258.715zm0 0"/>'
  }
})
